import React, { useEffect, useState } from 'react'
import { AuthenticateDocument } from '../../utils/AuthenticateDocument';
import MainLayout from '../MainLayout';
import External from '../ExternalUser';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { useParams } from 'react-router-dom';

const MileGrid = ({ isExternal = false, isTemplateDocument = false }) => {

    const { id } = useParams();
    const { conflictPreviewVerion, setConflictPreviewVerion, setIsReadOnly, setIsTemplateDocument } = useDocument();
    const [isAuthenticating, setIsAuthenticating] = useState(true);

    useEffect(() => {
        setIsTemplateDocument(isTemplateDocument);
        const searchParams = new URLSearchParams(document.location.search)
        const previewVerion = searchParams.get("versionType");
        if (previewVerion) {
            setConflictPreviewVerion(previewVerion);
            setIsReadOnly(true);
        }

    }, [id]);

    return (
        <div className='App'>
            {isExternal ? (
                <External />
            ) : isAuthenticating && !conflictPreviewVerion ? (
                <AuthenticateDocument setIsLoading={setIsAuthenticating} />
            ) : (
                <MainLayout />
            )}
        </div>
    )
}

export default MileGrid;